<template>
  <div class="p-4 bg-secondary-3 mt-3 rounded">
    <i
      aria-controls="statusBlock"
      aria-expanded="false"
      class="fas fa-lg mr-3"
      :class="{
        'fa-chevron-circle-right color-dark-gray': collapsed,
        'fa-chevron-circle-down color-green': !collapsed,
      }"
      data-toggle="collapse"
      href="#statusBlock"
      role="button"
      @click="
        () => {
          collapsed = !collapsed;
        }
      "
    />
    <span class="color-dark-gray font-weight-bold">
      <i class="fas fa-list-ul color-orange mr-2" />
      Leyenda de Estatus de historial de Reembolso de Consulta de Ubicación
    </span>
    <div id="statusBlock" class="collapse bg-secondary-9 py-2">
      <div
        v-for="(item, idx) in statusList"
        :key="`status-list-${idx}`"
        class="row mx-0 rounded py-1 px-2 color-gray"
      >
        <div class="col-md-2 row mx-0">
          <i
            class="fas fa-circle mr-2 font-12 statusColor"
            :style="`color: ${item.statusColor}`"
          />
          <span class="font-16 font-weight-bold">
            {{ item.statusDescription }}
          </span>
        </div>
        <div class="col-md-10 row mx-0">
          <span class="font-16 font-weight-normal">
            {{ item.legendDescription }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatusLeyend',
  props: {
    statusList: {
      type: Array,
      required: true,
    },
  },
  data: () => ({ collapsed: true }),
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/v2/brand_variables.scss';

.border-responsive {
  border-right: 1px solid $gray-400;
}

.leyend-title-size {
  width: 110px;
}
.statusColor {
  padding-top: 6px;
}

@media only screen and (max-width: 768px) {
  .border-responsive {
    border-right: unset;
    border-bottom: 1px solid $gray-400;
  }
}
</style>
